import { useEffect, useState } from 'react';

import AssetsGrid from 'components/AssetsGrid';
import Page from 'components/Page';

import useAssets from 'hooks/useAssets';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AssetsPage: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { assets = [], fetch } = useAssets();
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={`${className} ${styles.assetsPage}`} testId={testId}>
            <AssetsGrid onNext={hasMore ? handleNext : undefined} rows={assets} />
        </Page>
    );
};

export default AssetsPage;
